import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["connections"];
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { List } from 'immutable';
import ConnectionKeys from 'automation-ui-action-features/constants/ConnectionKeys';
import StaticBranch from 'automation-ui-action-features/records/StaticBranch';
import BranchConnectionMixin, { BranchConnectionMixinDefaultValues, branchConnectionFromJSON } from 'automation-ui-action-features/records/connection/BranchConnectionMixin';
const StaticBranchConnectionDefaultValues = Object.assign({}, BranchConnectionMixinDefaultValues, {
  [ConnectionKeys.STATIC_BRANCHES]: []
});
export default class StaticBranchConnection extends BranchConnectionMixin(createImmutableObjectClass(StaticBranchConnectionDefaultValues, {
  fromJSON: _ref => {
    let _ConnectionKeys$STATI = ConnectionKeys.STATIC_BRANCHES,
      {
        [_ConnectionKeys$STATI]: connections
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, [_ConnectionKeys$STATI].map(_toPropertyKey));
    return Object.assign({}, rest, branchConnectionFromJSON(rest), {
      connections: List((connections || []).map(branchJSON => new StaticBranch(branchJSON)))
    });
  },
  toJSON: _ref2 => {
    let {
        connections
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
    return Object.assign({}, rest, {
      connections: connections.map(branch => branch.toJSON()).toArray()
    });
  }
})) {
  getBranches() {
    return this[ConnectionKeys.STATIC_BRANCHES];
  }
  setBranches(staticBranches) {
    return this.set(ConnectionKeys.STATIC_BRANCHES, staticBranches);
  }
}